interface GraphQLErrorLike {
  message?: string;
  extensions?: { originalError?: string };
}

export function extractErrorMessage(e: any): string | undefined {
  const first: GraphQLErrorLike | undefined = Array.isArray(e) ? e[0] : e;
  return first?.extensions?.originalError || first?.message;
}
